import {initializeApp} from 'firebase/app';

import {Environment} from '../../constants';

export const firebaseApp = initializeApp(Environment.firebase.app);
